import React from 'react';

const Exploration = () => {
  return (
    <div className="accordion-body">
      <div className="content">
        <p>
          We have consistently added more to our Reserves and Resources (R&R) through brownfield and greenfield
          activities. This helps us to extend the lives of our existing mines and oilfields.
        </p>
      </div>
    </div>
  );
};

export default Exploration;
